import 'boxicons';
import React, {useState, useEffect} from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import EmpresaEmpresaBodyMarketPlace from './EmpresaEmpresaBodyMarketPlace';
import './stylesMarketplace.css';
import { ListadoEmpresaBodyMarketplace } from './ListadoEmpresaBodyMarketplace';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import {Riple} from 'react-loading-indicators';

/* A function that returns a component. */
function EmpresasBodyMarketPlace({Empresas, setEmpresas, NombreBuscar, categorias, buscarNombre, listaRating, sortBy, loading}) {

	return (
		<div>
            <div className='listadoContent'>
                <small className='text-muted'>Resultados de la búsqueda</small>
                {!loading ?
                    Empresas ?
                        Empresas.length > 0 ?
                            (() => {
                                const empresasFiltradas = Empresas.filter(empresa => listaRating.length === 0 || listaRating.includes(String(Math.round(empresa.puntuacion))));
                                return empresasFiltradas.length > 0 ?
                                    empresasFiltradas.map((empresa) => (
                                        <ListadoEmpresaBodyMarketplace
                                            numEmpresa={empresa.id}
                                            key={empresa.id}
                                            empresa={empresa}
                                            rating={true}
                                            categorias={categorias}
                                        />
                                    )) :
                                    <div className='listado'>
                                        <div className="listadoEmpresa text-bg-light container-fluid centrador listadoVacio text-center">
                                            <p>
                                            En esta ciudad, en Cuidatia, no tenemos servicios acreditados. Mientras tanto, te ofrecemos otras opciones.{" "}
                                            <a href="/club-cuidatia" className="btn-club-cuidatia">
                                                ¿Quieres ser miembro del Club Cuidatia?
                                            </a>
                                            </p>
                                        </div>
                                    </div>
                            })()
                        : <div className='listado'>
                            <div className="listadoEmpresa text-bg-light container-fluid centrador listadoVacio text-center">
                                <p>
                                En esta ciudad, en Cuidatia, no tenemos servicios acreditados. Mientras tanto, te ofrecemos otras opciones.{" "}
                                <a href="/club-cuidatia" className="btn-club-cuidatia">
                                    ¿Quieres ser miembro del Club Cuidatia?
                                </a>
                                </p>
                            </div>
                        </div>
                    :
                    <div className='listado'>
                        <div className="listadoEmpresa text-bg-light container-fluid centrador listadoVacio text-center">
                            <p>
                            En esta ciudad, en Cuidatia, no tenemos servicios acreditados. Mientras tanto, te ofrecemos otras opciones.{" "}
                            <a href="/club-cuidatia" className="btn-club-cuidatia">
                                ¿Quieres ser miembro del Club Cuidatia?
                            </a>
                            </p>
                        </div>
                    </div>
                :<div>
                    <div className='listadoEmpresa text-bg-light container-fluid centrador listadoVacio'>
                        <Riple color="#23a87e" size="medium" text="" textColor="" />
                    </div>
                </div>
                }
            </div>
        </div>
	);
}

export default EmpresasBodyMarketPlace;

/*
    (empresa.nombreEmpresa.toLowerCase().includes(NombreBuscar.toLowerCase())) &&
    <EmpresaEmpresaBodyMarketPlace
        numEmpresa={empresa.id}
        key={empresa.id}
        empresa={empresa}
    />
const { ident } = props;

const [NumEmpresas, setNumEmpresas] = useState(
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11 , 12 , 13 , 14]
)

const [Scroll, setScroll] = useState(true)

const masEmpresas = () => {
    let lista = []

    NumEmpresas.map((element) => {
        lista.push(element)
        return element
    })

    lista.push(lista.length + 1)
    lista.push(lista.length + 1)
    lista.push(lista.length + 1)

    setNumEmpresas(lista)

    if (NumEmpresas.length >= 20) {
        setScroll(false)
    }

}
/ A state that is used to detect the initial scroll position. 
const [scrollX, setscrollX] = useState(0);  // Para detectar la posición de desplazamiento inicial
// A state that is used to detect the end of the scroll. 
const [scrolEnd, setscrolEnd] = useState(false);  // Para detectar el final del desplazamiento 
// A reference to the scrollable element. 
let scrl = useRef(null);

// Slide() is a function that takes a shift value as an argument and scrolls the scrollable element by
// that amount
const slide = (shift) => {
    scrl.current.scrollLeft += shift;
    setscrollX(scrollX + shift);

    if (
        Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
        scrl.current.offsetWidth
    ) {
        setscrolEnd(true);
    } else {
        setscrolEnd(false);
    }
};

// When the user hovers over the element, the element will scale up to 1.2 times its original size.
const anim = (e) => {
    gsap.from(e.target, { scale: 1 });
    gsap.to(e.target, { scale: 1.2 });
};

// When the user hovers over the element, it will scale up to 1.2 and then scale back down to 1.
const anim2 = (e) => {
    gsap.from(e.target, { scale: 1.2 });
    gsap.to(e.target, { scale: 1 });
};

// It checks if the scrollbar is at the end of the page.
const scrollCheck = () => {
    setscrollX(scrl.current.scrollLeft);
    if (
        Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
        scrl.current.offsetWidth
    ) {
        setscrolEnd(true);
    } else {
        setscrolEnd(false);
    }
};
*/

/*
<InfiniteScroll
dataLength={NumEmpresas.length}
next={masEmpresas}
hasMore={Scroll}
style={{ overflow: "hidden" }}
>
{NumEmpresas.map((element, key) => (
    <EmpresaEmpresaBodyMarketPlace
        numEmpresa={element}
        key={key}
    />
))}

</InfiniteScroll>
    <div className="empresaempresabodymarketplace-container" Id={"container" + ident} >
    {
        NumEmpresas.map((numEmpresa) => <EmpresaEmpresaBodyMarketPlace
        className="item"
        numEmpresa={numEmpresa}
        key={numEmpresa.id}
        />
        )
    }
    </div>
*/
